module.exports = __webpack_public_path__ + "images/favicon-32x32.2a791ff4455df515e6e4f45c321accb1.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/favicon-32x32.png
// module id = 999
// module chunks = 0